/* eslint-disable no-unused-vars */
import { PPI } from "@/box/constants.js"
import { calculateSecondPointXFromAngleAndDistance } from "@/box/utils/common.js"

function getSvgForGeom(box) {
  const svgWidth = box.getDocumentWidth();
  const svgHeight = box.getDocumentHeight();

  let svg = `
          <svg
          xmlns="http://www.w3.org/2000/svg"
          width="${svgWidth}"
          height="${svgHeight}"
          viewBox="0 0 ${svgWidth} ${svgHeight}"
          stroke="blue"
          stroke-width="0.01" >
          `;

  box.panels.forEach((panel) => {
    svg += `<path fill="none" data-panelName="${panel.name} ${panel.row}Row" data-panelWidth="${panel.width}" data-panelHeight="${panel.height}" d="${panel.path}"/>`;
  })

  svg += "</svg>";

  return svg;
}

function get2DEditorSvg(box, printSide = "outside") {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  const largerDocumentDimension = documentWidth > documentHeight ? documentWidth : documentHeight
  const strokeWidth = largerDocumentDimension / 3000

  let svg = `
    <svg width="${documentWidth}" height="${documentHeight}" viewBox="0 0 ${documentWidth} ${documentHeight}" stroke-width="${strokeWidth}" xmlns="http://www.w3.org/2000/svg" version="1.1">
  `

  svg += getOutline(box, printSide)

  svg += getCutlines(box, printSide)

  svg += `</svg>`;
  return svg
}

function createPathDefinitionForOutlineWithBleed(box, isNormalized = false) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  // Normalizes x between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedX(x) {
    return isNormalized ? x / documentWidth : x;
  }

  // Normalizes y between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedY(y) {
    return isNormalized ? y / documentHeight : y;
  }

  const B = box.bleedInPx
  const MT = box.materialThicknessInPx
  const D = box.depthInPx
  const OW = box.overlapWidthInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const topRightDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapRight")
  const topLeftDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapLeft")
  const insideRightWall = panels.find(panel => panel.name === "insideRightWall")
  const outsideBackWallDustFlapRight = panels.find(panel => panel.name === "outsideBackWallDustFlapRight")
  const outsideBackWallDustFlapLeft = panels.find(panel => panel.name === "outsideBackWallDustFlapLeft")
  const leftClosingFlap = panels.find(panel => panel.name === "leftClosingFlap")
  const rightClosingFlap = panels.find(panel => panel.name === "rightClosingFlap")
  const outsideRightWall = panels.find(panel => panel.name === "outsideRightWall")
  const outsideLeftWall = panels.find(panel => panel.name === "outsideLeftWall")
  const topSide = panels.find(panel => panel.name === "topSide")

  const leftDustFlapOutside = panels.find(panel => panel.name === "leftDustFlapOutside")
  leftDustFlapOutside.point1.x *= PPI
  leftDustFlapOutside.point1.y *= PPI
  leftDustFlapOutside.point4.x *= PPI
  leftDustFlapOutside.point4.y *= PPI

  const rightDustFlapOutside = panels.find(panel => panel.name === "rightDustFlapOutside")
  rightDustFlapOutside.point2.x *= PPI
  rightDustFlapOutside.point2.y *= PPI
  rightDustFlapOutside.point3.x *= PPI
  rightDustFlapOutside.point3.y *= PPI

  const d = `
    M ${adjustedX(documentWidth / 2)} ${adjustedY(0)}
    L ${adjustedX((topRightDustFlap.left + topRightDustFlap.width) + B)} ${adjustedY(0)}
    V ${adjustedY(topRightDustFlap.top + topRightDustFlap.height - B)}
    H ${adjustedX(outsideRightWall.left + outsideRightWall.width)}
    l ${adjustedX(OW)} ${adjustedY(2*MT)}
    h ${adjustedX(insideRightWall.width + B)}
    v ${adjustedY(insideRightWall.height + 2*B)}
    h ${adjustedX(-insideRightWall.width - B)}
    l ${adjustedX(-OW)} ${adjustedY(2*MT)}
    L ${adjustedX(outsideBackWallDustFlapRight.left + outsideBackWallDustFlapRight.width + B)} ${adjustedY(outsideBackWallDustFlapRight.top + B)}
    v ${adjustedY(outsideBackWallDustFlapRight.height)}
    L ${
      adjustedX(calculateSecondPointXFromAngleAndDistance(
        rightDustFlapOutside.point2.x,
        rightDustFlapOutside.point2.y,
        outsideBackWallDustFlapRight.top + outsideBackWallDustFlapRight.height + B,
        10
      ).x)
    } ${adjustedY(outsideBackWallDustFlapRight.top + outsideBackWallDustFlapRight.height + B)}
    L ${adjustedX(rightDustFlapOutside.point2.x)} ${adjustedY(rightDustFlapOutside.point2.y - B)}
    Q ${adjustedX(rightDustFlapOutside.point2.x + (1 * PPI) + B)} ${adjustedY(rightDustFlapOutside.point2.y + (0.35 * PPI) - B)} ${adjustedX(rightDustFlapOutside.point2.x + (1.15  * PPI) + B)} ${adjustedY(rightDustFlapOutside.point2.y + (1.15  * PPI))}
    L ${adjustedX(rightDustFlapOutside.point3.x + (1.15 * PPI) + B)} ${adjustedY(rightDustFlapOutside.point3.y - (1.15 * PPI))}
    Q ${adjustedX(rightDustFlapOutside.point3.x + (0.85 * PPI) + B)} ${adjustedY(rightDustFlapOutside.point3.y - (0.35 * PPI) + B)} ${adjustedX(rightDustFlapOutside.point3.x)} ${adjustedY(rightDustFlapOutside.point3.y + B)}
    L ${adjustedX(rightDustFlapOutside.left + B)}  ${adjustedY(rightDustFlapOutside.top + rightDustFlapOutside.height + B)}
    v ${
      // @TODO: fix this.
      adjustedY(4 *MT - B - B)
    }
    L ${adjustedX(rightClosingFlap.left + rightClosingFlap.width - (0.65  * PPI))} ${adjustedY(rightClosingFlap.top - B)}
    Q ${adjustedX(rightClosingFlap.left + rightClosingFlap.width - (0.15  * PPI) + B)} ${adjustedY(rightClosingFlap.top + (0.15  * PPI) - B)} ${adjustedX(rightClosingFlap.left + rightClosingFlap.width + B)} ${adjustedY(rightClosingFlap.top + (0.65 * PPI))}
    L ${adjustedX(rightClosingFlap.left + rightClosingFlap.width + B)} ${adjustedY(rightClosingFlap.top + rightClosingFlap.height - (1.5  * PPI))}
    Q ${adjustedX(rightClosingFlap.left + rightClosingFlap.width + B)} ${adjustedY(rightClosingFlap.top + rightClosingFlap.height - (0.15 * PPI) + B)} ${adjustedX(rightClosingFlap.left)} ${adjustedY(rightClosingFlap.top + rightClosingFlap.height + B)}
    L ${adjustedX(documentWidth / 2)} ${adjustedY(documentHeight)}
    L ${adjustedX(leftClosingFlap.left + leftClosingFlap.width)} ${adjustedY(documentHeight)}
    Q ${adjustedX(leftClosingFlap.left + (0.15 * PPI) - B)} ${adjustedY(leftClosingFlap.top + leftClosingFlap.height - (0.15 * PPI) + B)} ${adjustedX(leftClosingFlap.left - B)} ${adjustedY(leftClosingFlap.top + leftClosingFlap.height - (1.5 * PPI))}
    L ${adjustedX(leftClosingFlap.left - B)} ${adjustedY(leftClosingFlap.top + (0.65 * PPI))}
    Q ${adjustedX(leftClosingFlap.left + (0.15 * PPI) - B)} ${adjustedY(leftClosingFlap.top + (0.1 * PPI) - B)} ${adjustedX(leftClosingFlap.left + (0.65 * PPI))} ${adjustedY(leftClosingFlap.top - B)}
    H ${adjustedX(leftDustFlapOutside.left + leftDustFlapOutside.width - B)}
    v ${
      // @TODO: fix this.
      adjustedY(-4 *MT + B + B)
    }
    L ${adjustedX(leftDustFlapOutside.point4.x)} ${adjustedY(leftDustFlapOutside.point4.y + B)}
    Q ${adjustedX(leftDustFlapOutside.point4.x - (1 * PPI) - B)} ${adjustedY(leftDustFlapOutside.point4.y - (0.35 * PPI) + B)} ${adjustedX(leftDustFlapOutside.left - B)} ${adjustedY(leftDustFlapOutside.point4.y - (1.15  * PPI))}
    L ${adjustedX(leftDustFlapOutside.left - B)} ${adjustedY(leftDustFlapOutside.top + (1.5 * PPI))}
    Q ${adjustedX(leftDustFlapOutside.left + (0.15 * PPI) - B)} ${adjustedY(leftDustFlapOutside.point1.y + (0.35 * PPI) - B)} ${adjustedX(leftDustFlapOutside.point1.x)} ${adjustedY(leftDustFlapOutside.point1.y - B)}
    L ${
      adjustedX(calculateSecondPointXFromAngleAndDistance(
        leftDustFlapOutside.point1.x,
        leftDustFlapOutside.point1.y,
        outsideBackWallDustFlapLeft.top + outsideBackWallDustFlapLeft.height + B,
        -10
      ).x)
    } ${adjustedY(outsideBackWallDustFlapLeft.top + outsideBackWallDustFlapLeft.height + B)}
    H ${
      adjustedX(outsideBackWallDustFlapLeft.left - B)
    }
    v ${adjustedY(-outsideBackWallDustFlapRight.height)}
    L ${adjustedX(outsideLeftWall.left)} ${adjustedY(outsideBackWallDustFlapRight.top + B)}
    l ${adjustedX(-OW)} ${adjustedY(-2* MT)}
    h ${adjustedX(-insideRightWall.width - B)}
    v ${adjustedY(-insideRightWall.height - 2*B)}
    h ${adjustedX(insideRightWall.width + B)}
    l ${adjustedX(OW)} ${adjustedY(-2*MT)}
    L ${adjustedX(topLeftDustFlap.left - B)} ${adjustedY(topLeftDustFlap.top + topLeftDustFlap.height - B)}
    v ${adjustedY(-topLeftDustFlap.height)}
    L ${adjustedX(documentWidth / 2)} ${adjustedY(0)}
    Z
  `
  return d
}

function getOutlineWithBleed(box, isNormalized = false, printSide = 'outside') {
  const transformElement = printSide === 'inside' ? `transform: scaleX(-1) translateX(-1px);` : ''

  const path = `
    <path
      style="${transformElement}"
      stroke="green"
      fill="#000000"
      d="${createPathDefinitionForOutlineWithBleed(box, isNormalized)}"
    />
  `
  return path
}

function createPathDefinitionForOutlineWithoutNonPrintPanels(box, isNormalized = false) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  // Normalizes x between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedX(x) {
    return isNormalized ? x / documentWidth: x;
  }

  // Normalizes y between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedY(y) {
    return isNormalized ? y / documentHeight : y;
  }

  const B = box.bleedInPx
  const MT = box.materialThicknessInPx
  const OW = box.overlapWidthInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const topRightDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapRight")
  const topLeftDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapLeft")
  const insideRightWall = panels.find(panel => panel.name === "insideRightWall")
  const outsideBackWallDustFlapRight = panels.find(panel => panel.name === "outsideBackWallDustFlapRight")
  const outsideBackWallDustFlapLeft = panels.find(panel => panel.name === "outsideBackWallDustFlapLeft")
  const leftClosingFlap = panels.find(panel => panel.name === "leftClosingFlap")
  const rightClosingFlap = panels.find(panel => panel.name === "rightClosingFlap")
  const outsideFrontWall = panels.find(panel => panel.name === "outsideFrontWall")
  const outsideRightWall = panels.find(panel => panel.name === "outsideRightWall")
  const outsideLeftWall = panels.find(panel => panel.name === "outsideLeftWall")
  const outsideBackWall = panels.find(panel => panel.name === "outsideBackWall")

  const leftDustFlapOutside = panels.find(panel => panel.name === "leftDustFlapOutside")
  leftDustFlapOutside.point1.x *= PPI
  leftDustFlapOutside.point1.y *= PPI
  leftDustFlapOutside.point4.x *= PPI
  leftDustFlapOutside.point4.y *= PPI

  const rightDustFlapOutside = panels.find(panel => panel.name === "rightDustFlapOutside")
  rightDustFlapOutside.point2.x *= PPI
  rightDustFlapOutside.point2.y *= PPI
  rightDustFlapOutside.point3.x *= PPI
  rightDustFlapOutside.point3.y *= PPI

  const d = `
    M ${adjustedX(documentWidth / 2)} ${adjustedY(0)}
    h ${adjustedX(outsideFrontWall.width / 2 + B)}
    v ${adjustedY(topRightDustFlap.height)}
    H ${adjustedX(outsideRightWall.left + outsideRightWall.width)}
    l ${adjustedX(OW)} ${adjustedY(2*MT)}
    h ${adjustedX(insideRightWall.width + B)}
    v ${adjustedY(insideRightWall.height + 2*B)}
    h ${adjustedX(-insideRightWall.width - B)}
    l ${adjustedX(-OW)} ${adjustedY(2*MT)}
    L ${adjustedX(outsideBackWallDustFlapRight.left + B)} ${adjustedY(outsideBackWallDustFlapRight.top + B)}
    V ${adjustedY(outsideBackWall.top + outsideBackWall.height)}
    L ${adjustedX(rightDustFlapOutside.point2.x)} ${adjustedY(rightDustFlapOutside.point2.y - B)}
    Q ${adjustedX(rightDustFlapOutside.point2.x + (1 * PPI) + B)} ${adjustedY(rightDustFlapOutside.point2.y + (0.35 * PPI) - B)} ${adjustedX(rightDustFlapOutside.point2.x + (1.15  * PPI) + B)} ${adjustedY(rightDustFlapOutside.point2.y + (1.15  * PPI))}
    L ${adjustedX(rightDustFlapOutside.point3.x + (1.15 * PPI) + B)} ${adjustedY(rightDustFlapOutside.point3.y - (1.15 * PPI))}
    Q ${adjustedX(rightDustFlapOutside.point3.x + (0.85 * PPI) + B)} ${adjustedY(rightDustFlapOutside.point3.y - (0.4 * PPI) + B)} ${adjustedX(rightDustFlapOutside.point3.x)} ${adjustedY(rightDustFlapOutside.point3.y + B)}
    L ${adjustedX(rightDustFlapOutside.left + B)}  ${adjustedY(rightDustFlapOutside.top + rightDustFlapOutside.height + B)}
    v ${
      // @TODO: fix this.
      adjustedY(4 *MT - B - B)
    }
    L ${adjustedX(rightClosingFlap.left + rightClosingFlap.width - (0.65  * PPI))} ${adjustedY(rightClosingFlap.top - B)}
    Q ${adjustedX(rightClosingFlap.left + rightClosingFlap.width - (0.15  * PPI) + B)} ${adjustedY(rightClosingFlap.top + (0.15  * PPI) - B)} ${adjustedX(rightClosingFlap.left + rightClosingFlap.width + B)} ${adjustedY(rightClosingFlap.top + (0.65 * PPI))}
    L ${adjustedX(rightClosingFlap.left + rightClosingFlap.width + B)} ${adjustedY(rightClosingFlap.top + rightClosingFlap.height - (1.5  * PPI))}
    Q ${adjustedX(rightClosingFlap.left + rightClosingFlap.width + B)} ${adjustedY(rightClosingFlap.top + rightClosingFlap.height - (0.15 * PPI) + B)} ${adjustedX(rightClosingFlap.left)} ${adjustedY(rightClosingFlap.top + rightClosingFlap.height + B)}
    L ${adjustedX(documentWidth / 2)} ${adjustedY(documentHeight)}
    L ${adjustedX(leftClosingFlap.left + leftClosingFlap.width)} ${adjustedY(documentHeight)}
    Q ${adjustedX(leftClosingFlap.left + (0.15 * PPI) - B)} ${adjustedY(leftClosingFlap.top + leftClosingFlap.height - (0.15 * PPI) + B)} ${adjustedX(leftClosingFlap.left - B)} ${adjustedY(leftClosingFlap.top + leftClosingFlap.height - (1.5 * PPI))}
    L ${adjustedX(leftClosingFlap.left - B)} ${adjustedY(leftClosingFlap.top + (0.65 * PPI))}
    Q ${adjustedX(leftClosingFlap.left + (0.15 * PPI) - B)} ${adjustedY(leftClosingFlap.top + (0.1 * PPI) - B)} ${adjustedX(leftClosingFlap.left + (0.65 * PPI))} ${adjustedY(leftClosingFlap.top - B)}
    H ${adjustedX(leftClosingFlap.left + leftClosingFlap.width + 4*MT - B)}
    v ${
      // @TODO: fix this.
      adjustedY(-4 *MT + B + B)
    }
    L ${adjustedX(leftDustFlapOutside.point4.x)} ${adjustedY(leftDustFlapOutside.point4.y + B)}
    Q ${adjustedX(leftDustFlapOutside.point4.x - (1 * PPI) - B)} ${adjustedY(leftDustFlapOutside.point4.y - (0.4 * PPI) + B)} ${adjustedX(leftDustFlapOutside.left - B)} ${adjustedY(leftDustFlapOutside.point4.y - (1.15  * PPI))}
    L ${adjustedX(leftDustFlapOutside.left - B)} ${adjustedY(leftDustFlapOutside.top + (1.5 * PPI))}
    Q ${adjustedX(leftDustFlapOutside.left + (0.15 * PPI) - B)} ${adjustedY(leftDustFlapOutside.point1.y + (0.35 * PPI) - B)} ${adjustedX(leftDustFlapOutside.point1.x)} ${adjustedY(leftDustFlapOutside.point1.y - B)}
    L ${
      // @TODO: fix this.
      adjustedX((leftDustFlapOutside.left + leftDustFlapOutside.width - B) - 2*B)
    } ${adjustedY(outsideBackWall.top + outsideBackWall.height)}
    H ${
      // @TODO: fix this. +3 is temp fix
      adjustedX(outsideBackWallDustFlapLeft.left + outsideBackWallDustFlapRight.width - B)
    }
    V ${adjustedY(outsideBackWallDustFlapLeft.top + B)}
    L ${adjustedX(outsideLeftWall.left)} ${adjustedY(outsideBackWallDustFlapRight.top + B)}
    l ${adjustedX(-OW)} ${adjustedY(-2* MT)}
    h ${adjustedX(-insideRightWall.width - B)}
    v ${adjustedY(-insideRightWall.height - 2*B)}
    h ${adjustedX(insideRightWall.width + B)}
    l ${adjustedX(OW)} ${adjustedY(-2*MT)}
    L ${adjustedX(topLeftDustFlap.left + topLeftDustFlap.width - B)} ${adjustedY(topLeftDustFlap.top + topLeftDustFlap.height - B)}
    v ${adjustedY(-topLeftDustFlap.height)}
    L ${adjustedX(documentWidth / 2)} ${adjustedY(0)}
    Z
  `
  return d
}

function createPathDefinitionForOutlineWithoutNonPrintPanelsForInsidePrint(box, isNormalized = false) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  // Normalizes x between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedX(x) {
    return isNormalized ? x / documentWidth: x;
  }

  // Normalizes y between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedY(y) {
    return isNormalized ? y / documentHeight : y;
  }

  const B = box.bleedInPx
  const MT = box.materialThicknessInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const topRightDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapRight")
  const topLeftDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapLeft")
  const outsideBackWallDustFlapRight = panels.find(panel => panel.name === "outsideBackWallDustFlapRight")
  const outsideBackWallDustFlapLeft = panels.find(panel => panel.name === "outsideBackWallDustFlapLeft")
  const leftClosingFlap = panels.find(panel => panel.name === "leftClosingFlap")
  const rightClosingFlap = panels.find(panel => panel.name === "rightClosingFlap")
  const outsideFrontWall = panels.find(panel => panel.name === "outsideFrontWall")

  const outsideBottom = panels.find(panel => panel.name === "outsideBottom")

  const leftDustFlapOutside = panels.find(panel => panel.name === "leftDustFlapOutside")
  leftDustFlapOutside.point1.x *= PPI
  leftDustFlapOutside.point1.y *= PPI
  leftDustFlapOutside.point4.x *= PPI
  leftDustFlapOutside.point4.y *= PPI

  const rightDustFlapOutside = panels.find(panel => panel.name === "rightDustFlapOutside")
  rightDustFlapOutside.point2.x *= PPI
  rightDustFlapOutside.point2.y *= PPI
  rightDustFlapOutside.point3.x *= PPI
  rightDustFlapOutside.point3.y *= PPI

  const d = `
    M ${adjustedX(documentWidth / 2)} ${adjustedY(0)}
    h ${adjustedX(outsideFrontWall.width / 2 + B)}
    v ${adjustedY(topRightDustFlap.height)}
    H ${adjustedX(outsideBottom.left + outsideBottom.width + B)}
    L ${adjustedX(outsideBottom.left + outsideBottom.width + B)} ${adjustedY(outsideBackWallDustFlapRight.top + B)}
    H ${adjustedX(outsideBottom.left + outsideBottom.width)}
    v ${adjustedY(outsideBackWallDustFlapRight.height)}
    L ${adjustedX(rightDustFlapOutside.point2.x)} ${adjustedY(rightDustFlapOutside.point2.y - B)}
    h ${
      // @TODO: Fix this
      adjustedX(B)
    }
    Q ${adjustedX(rightDustFlapOutside.point2.x + (1 * PPI) + B)} ${adjustedY(rightDustFlapOutside.point2.y + (0.35 * PPI) - B)} ${adjustedX(rightDustFlapOutside.point2.x + (1.15  * PPI) + B)} ${adjustedY(rightDustFlapOutside.point2.y + (1.15  * PPI))}
    L ${adjustedX(rightDustFlapOutside.point3.x + (1.15 * PPI) + B)} ${adjustedY(rightDustFlapOutside.point3.y - (1.15 * PPI))}
    Q ${adjustedX(rightDustFlapOutside.point3.x + (0.85 * PPI) + B)} ${adjustedY(rightDustFlapOutside.point3.y - (0.25 * PPI) + B)} ${adjustedX(rightDustFlapOutside.point3.x)} ${adjustedY(rightDustFlapOutside.point3.y + B)}
    L ${adjustedX(rightDustFlapOutside.left + B)}  ${adjustedY(rightDustFlapOutside.top + rightDustFlapOutside.height + B)}
    v ${
      // @TODO: fix this.
      adjustedY(4 *MT - B - B)
    }
    L ${adjustedX(rightClosingFlap.left + rightClosingFlap.width - (0.65  * PPI))} ${adjustedY(rightClosingFlap.top - B)}
    Q ${adjustedX(rightClosingFlap.left + rightClosingFlap.width - (0.15  * PPI) + B)} ${adjustedY(rightClosingFlap.top + (0.15  * PPI) - B)} ${adjustedX(rightClosingFlap.left + rightClosingFlap.width + B)} ${adjustedY(rightClosingFlap.top + (0.65 * PPI))}
    L ${adjustedX(rightClosingFlap.left + rightClosingFlap.width + B)} ${adjustedY(rightClosingFlap.top + rightClosingFlap.height - (1.5  * PPI))}
    Q ${adjustedX(rightClosingFlap.left + rightClosingFlap.width + B)} ${adjustedY(rightClosingFlap.top + rightClosingFlap.height - (0.15 * PPI) + B)} ${adjustedX(rightClosingFlap.left)} ${adjustedY(rightClosingFlap.top + rightClosingFlap.height + B)}
    L ${adjustedX(documentWidth / 2)} ${adjustedY(documentHeight)}
    L ${adjustedX(leftClosingFlap.left + leftClosingFlap.width)} ${adjustedY(documentHeight)}
    Q ${adjustedX(leftClosingFlap.left + (0.15 * PPI) - B)} ${adjustedY(leftClosingFlap.top + leftClosingFlap.height - (0.15 * PPI) + B)} ${adjustedX(leftClosingFlap.left - B)} ${adjustedY(leftClosingFlap.top + leftClosingFlap.height - (1.5 * PPI))}
    L ${adjustedX(leftClosingFlap.left - B)} ${adjustedY(leftClosingFlap.top + (0.65 * PPI))}
    Q ${adjustedX(leftClosingFlap.left + (0.15 * PPI) - B)} ${adjustedY(leftClosingFlap.top + (0.1 * PPI) - B)} ${adjustedX(leftClosingFlap.left + (0.65 * PPI))} ${adjustedY(leftClosingFlap.top - B)}
    H ${adjustedX(leftClosingFlap.left + leftClosingFlap.width + 4*MT - B)}
    v ${
      // @TODO: fix this.
      adjustedY(-4 *MT + B + B)
    }
    L ${adjustedX(leftDustFlapOutside.point4.x)} ${adjustedY(leftDustFlapOutside.point4.y + B)}
    Q ${adjustedX(leftDustFlapOutside.point4.x - (1 * PPI) - B)} ${adjustedY(leftDustFlapOutside.point4.y - (0.25 * PPI) + B)} ${adjustedX(leftDustFlapOutside.left - B)} ${adjustedY(leftDustFlapOutside.point4.y - (1.15  * PPI))}
    L ${adjustedX(leftDustFlapOutside.left - B)} ${adjustedY(leftDustFlapOutside.top + (1.5 * PPI))}
    Q ${adjustedX(leftDustFlapOutside.left + (0.15 * PPI) - B)} ${adjustedY(leftDustFlapOutside.point1.y + (0.35 * PPI) - B)} ${adjustedX(leftDustFlapOutside.point1.x)} ${adjustedY(leftDustFlapOutside.point1.y - B)}
    L ${
      // @TODO: fix this.
      adjustedX((leftDustFlapOutside.left + leftDustFlapOutside.width - B) - 2*B)
    } ${adjustedY(outsideBackWallDustFlapLeft.top + outsideBackWallDustFlapLeft.height + B)}
    H ${
      adjustedX(outsideBackWallDustFlapLeft.left + outsideBackWallDustFlapRight.width - B)
    }
    v ${adjustedY(-outsideBackWallDustFlapRight.height)}
    H ${adjustedX(outsideBottom.left - B)}
    L ${adjustedX(outsideBottom.left - B)} ${adjustedY(topLeftDustFlap.top + topLeftDustFlap.height - B)}
    H ${adjustedX(outsideFrontWall.left - B)}
    v ${adjustedY(-topLeftDustFlap.height)}
    L ${adjustedX(documentWidth / 2)} ${adjustedY(0)}
    Z
  `
  return d
}

function getOutlineWithoutNonPrintPanels(box, isNormalized = false, printSide = 'outside') {
  const def = printSide === 'outside'
    ? createPathDefinitionForOutlineWithoutNonPrintPanels(box, isNormalized)
    : createPathDefinitionForOutlineWithoutNonPrintPanelsForInsidePrint(box, isNormalized)

  const transformStyle = printSide === 'outside' ? '' : `transform: scaleX(-1); transform-origin: center;`

  const path = `
    <path
      style="${transformStyle}"
      stroke="green"
      fill="#000000"
      d="${def}" />
  `
  return path
}

function createOutlinePathDefinition(box) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  const B = box.bleedInPx
  const MT = box.materialThicknessInPx
  const W = box.widthInPx
  const L = box.lengthInPx
  const D = box.depthInPx
  const OW = box.overlapWidthInPx
  const FW = box.flapWidthInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const topRightDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapRight")
  const topLeftDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapLeft")
  const insideRightWall = panels.find(panel => panel.name === "insideRightWall")
  const outsideBackWallDustFlapRight = panels.find(panel => panel.name === "outsideBackWallDustFlapRight")
  const leftClosingFlap = panels.find(panel => panel.name === "leftClosingFlap")
  const rightClosingFlap = panels.find(panel => panel.name === "rightClosingFlap")
  const outsideRightWall = panels.find(panel => panel.name === "outsideRightWall")
  const outsideLeftWall = panels.find(panel => panel.name === "outsideLeftWall")

  const leftDustFlapOutside = panels.find(panel => panel.name === "leftDustFlapOutside")
  leftDustFlapOutside.point1.x *= PPI
  leftDustFlapOutside.point1.y *= PPI
  leftDustFlapOutside.point4.x *= PPI
  leftDustFlapOutside.point4.y *= PPI

  const rightDustFlapOutside = panels.find(panel => panel.name === "rightDustFlapOutside")
  rightDustFlapOutside.point2.x *= PPI
  rightDustFlapOutside.point2.y *= PPI
  rightDustFlapOutside.point3.x *= PPI
  rightDustFlapOutside.point3.y *= PPI

  const d = `
    M ${documentWidth / 2} ${B}
    L ${(topRightDustFlap.left + topRightDustFlap.width)} ${B}
    v ${topRightDustFlap.height}
    H ${outsideRightWall.left + outsideRightWall.width}
    l ${OW} ${2*MT}
    h ${insideRightWall.width}
    v ${insideRightWall.height}
    h ${-insideRightWall.width}
    l ${-OW} ${2*MT}
    L ${outsideBackWallDustFlapRight.left + outsideBackWallDustFlapRight.width} ${outsideBackWallDustFlapRight.top}
    v ${outsideBackWallDustFlapRight.height}
    h ${-outsideBackWallDustFlapRight.width}
    l ${-4*MT} ${ MT}
    v ${2*MT}
    L ${rightDustFlapOutside.point2.x} ${rightDustFlapOutside.point2.y}
    Q ${rightDustFlapOutside.point2.x + (1 * PPI)} ${rightDustFlapOutside.point2.y + (0.35 * PPI)} ${rightDustFlapOutside.point2.x + (1.15  * PPI)} ${rightDustFlapOutside.point2.y + (1.15  * PPI)}
    L ${rightDustFlapOutside.point3.x + (1.15 * PPI)} ${rightDustFlapOutside.point3.y - (1.15 * PPI)}
    Q ${rightDustFlapOutside.point3.x + (0.85 * PPI)} ${rightDustFlapOutside.point3.y - (0.35 * PPI)} ${rightDustFlapOutside.point3.x} ${rightDustFlapOutside.point3.y}
    L ${rightDustFlapOutside.left}  ${rightDustFlapOutside.top + rightDustFlapOutside.height}
    v ${4 *MT}
    L ${rightClosingFlap.left + rightClosingFlap.width - (0.65  * PPI)} ${rightClosingFlap.top}
    Q ${rightClosingFlap.left + rightClosingFlap.width - (0.15  * PPI)} ${rightClosingFlap.top + (0.15  * PPI)} ${rightClosingFlap.left + rightClosingFlap.width} ${rightClosingFlap.top + (0.65 * PPI)}
    L ${rightClosingFlap.left + rightClosingFlap.width} ${rightClosingFlap.top + rightClosingFlap.height - (1.5  * PPI)}
    Q ${rightClosingFlap.left + rightClosingFlap.width} ${rightClosingFlap.top + rightClosingFlap.height - (0.15 * PPI)} ${rightClosingFlap.left} ${rightClosingFlap.top + rightClosingFlap.height}
    L ${documentWidth / 2} ${documentHeight - B}
    L ${leftClosingFlap.left + leftClosingFlap.width} ${documentHeight - B}
    Q ${leftClosingFlap.left + (0.15 * PPI)} ${leftClosingFlap.top + leftClosingFlap.height - (0.15 * PPI)} ${leftClosingFlap.left} ${leftClosingFlap.top + leftClosingFlap.height - (1.5 * PPI)}
    L ${leftClosingFlap.left} ${leftClosingFlap.top + (0.65 * PPI)}
    Q ${leftClosingFlap.left + (0.15 * PPI)} ${leftClosingFlap.top + (0.1 * PPI)} ${leftClosingFlap.left + (0.65 * PPI)} ${leftClosingFlap.top}
    H ${leftClosingFlap.left + leftClosingFlap.width + 4*MT}
    v ${-4 *MT}
    L ${leftDustFlapOutside.point4.x} ${leftDustFlapOutside.point4.y}
    Q ${leftDustFlapOutside.point4.x - (1 * PPI)} ${leftDustFlapOutside.point4.y - (0.35 * PPI)} ${leftDustFlapOutside.left} ${leftDustFlapOutside.point4.y - (1.15  * PPI)}
    L ${leftDustFlapOutside.left} ${leftDustFlapOutside.top + (1.5 * PPI)}
    Q ${leftDustFlapOutside.left + (0.15 * PPI)} ${leftDustFlapOutside.point1.y + (0.35 * PPI)} ${leftDustFlapOutside.point1.x} ${leftDustFlapOutside.point1.y}
    L ${leftDustFlapOutside.left + leftDustFlapOutside.width} ${leftDustFlapOutside.top}
    v ${-2 *MT}
    l ${-4*MT} ${-MT}
    h ${-outsideBackWallDustFlapRight.width}
    v ${-outsideBackWallDustFlapRight.height}
    L ${outsideLeftWall.left} ${outsideBackWallDustFlapRight.top}
    l ${-OW} ${-2* MT}
    h ${-insideRightWall.width}
    v ${-insideRightWall.height}
    h ${insideRightWall.width}
    l ${OW} ${-2*MT}
    L ${topLeftDustFlap.left} ${topLeftDustFlap.top + topLeftDustFlap.height}
    v ${-topLeftDustFlap.height}
    L ${documentWidth / 2} ${B}
    Z
  `

  return d
}

function getOutline(box, printSide = 'outside') {
  const transformElement = printSide === 'inside'
    ? `transform: scaleX(-1); transform-origin: center;`
    : ''
  const path = `
    <path
      style="${transformElement}"
      stroke="blue"
      fill="none"
      d="${createOutlinePathDefinition(box)}" />
  `

  return path
}

function createCutlinesPathDefinition(box) {
  const MT = box.materialThicknessInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const outsideFrontWall = panels.find(panel => panel.name === "outsideFrontWall")
  const outsideBackWall = panels.find(panel => panel.name === "outsideBackWall")
  const topSide = panels.find(panel => panel.name === "topSide")
  const leftOverlap = panels.find(panel => panel.name === "leftOverlap")
  const rightOverlap = panels.find(panel => panel.name === "rightOverlap")
  const outsideBottom = panels.find(panel => panel.name === "outsideBottom")
  const frontFlapOutside = panels.find(panel => panel.name === "frontFlapOutside")

  const outsideFrontDustFlapLeft = panels.find(panel => panel.name === "outsideFrontDustFlapLeft")
  const outsideFrontDustFlapRight = panels.find(panel => panel.name === "outsideFrontDustFlapRight")
  const outsideBackWallDustFlapLeft = panels.find(panel => panel.name === "outsideBackWallDustFlapLeft")
  const outsideBackWallDustFlapRight = panels.find(panel => panel.name === "outsideBackWallDustFlapRight")

  // Red part of foldlines
  const redArea = `
    M ${outsideFrontWall.left} ${outsideFrontWall.top + outsideFrontWall.height}
    h ${outsideFrontWall.width}
    M ${outsideBackWall.left} ${outsideBackWall.top}
    h ${outsideBackWall.width}
    M ${outsideBackWall.left + 4*MT} ${outsideBackWall.top + outsideBackWall.height}
    h ${outsideBackWall.width - 8*MT}
    M ${topSide.left} ${topSide.top + topSide.height}
    h ${topSide.width}
    M ${outsideFrontDustFlapLeft.left + outsideFrontDustFlapLeft.width} ${outsideFrontDustFlapLeft.top}
    v ${outsideFrontDustFlapLeft.height}
    M ${outsideFrontDustFlapRight.left} ${outsideFrontDustFlapRight.top}
    v ${outsideFrontDustFlapRight.height}
    M ${leftOverlap.left} ${leftOverlap.top + 2*MT}
    v ${leftOverlap.height - 4*MT}
    M ${leftOverlap.left + leftOverlap.width} ${leftOverlap.top}
    v ${leftOverlap.height}
    M ${outsideBottom.left} ${outsideBottom.top}
    v ${outsideBottom.height}
    M ${outsideBottom.left + outsideBottom.width} ${outsideBottom.top}
    v ${outsideBottom.height}
    M ${rightOverlap.left} ${rightOverlap.top}
    v ${rightOverlap.height}
    M ${rightOverlap.left + rightOverlap.width} ${rightOverlap.top + 2*MT}
    v ${rightOverlap.height - 4*MT}
    M ${outsideBackWallDustFlapLeft.left + outsideBackWallDustFlapLeft.width} ${outsideBackWallDustFlapLeft.top}
    v ${outsideBackWallDustFlapLeft.height}
    M ${outsideBackWallDustFlapRight.left} ${outsideBackWallDustFlapRight.top}
    v ${outsideBackWallDustFlapRight.height}
    M ${topSide.left} ${topSide.top}
    v ${topSide.height}
    M ${topSide.left + topSide.width} ${topSide.top}
    v ${topSide.height}
    M ${frontFlapOutside.left} ${frontFlapOutside.top + 2*MT}
    v ${frontFlapOutside.height - 2*MT}
    M ${frontFlapOutside.left + frontFlapOutside.width} ${frontFlapOutside.top + 2*MT}
    v ${frontFlapOutside.height - 2*MT}
  `
  // White part of foldlines
  const whiteFoldLines = `
    M ${outsideFrontWall.left} ${outsideFrontWall.top + outsideFrontWall.height}
    h ${outsideFrontWall.width}
    M ${outsideBackWall.left} ${outsideBackWall.top}
    h ${outsideBackWall.width}
    M ${outsideBackWall.left + 4*MT} ${outsideBackWall.top + outsideBackWall.height}
    h ${outsideBackWall.width - 8*MT}
    M ${topSide.left} ${topSide.top + topSide.height}
    h ${topSide.width}
    M ${outsideFrontDustFlapLeft.left + outsideFrontDustFlapLeft.width} ${outsideFrontDustFlapLeft.top}
    v ${outsideFrontDustFlapLeft.height}
    M ${outsideFrontDustFlapRight.left} ${outsideFrontDustFlapRight.top}
    v ${outsideFrontDustFlapRight.height}
    M ${leftOverlap.left} ${leftOverlap.top + 2*MT}
    v ${leftOverlap.height - 4*MT}
    M ${leftOverlap.left + leftOverlap.width} ${leftOverlap.top}
    v ${leftOverlap.height}
    M ${outsideBottom.left} ${outsideBottom.top}
    v ${outsideBottom.height}
    M ${outsideBottom.left + outsideBottom.width} ${outsideBottom.top}
    v ${outsideBottom.height}
    M ${rightOverlap.left} ${rightOverlap.top}
    v ${rightOverlap.height}
    M ${rightOverlap.left + rightOverlap.width} ${rightOverlap.top + 2*MT}
    v ${rightOverlap.height - 4*MT}
    M ${outsideBackWallDustFlapLeft.left + outsideBackWallDustFlapLeft.width} ${outsideBackWallDustFlapLeft.top}
    v ${outsideBackWallDustFlapLeft.height}
    M ${outsideBackWallDustFlapRight.left} ${outsideBackWallDustFlapRight.top}
    v ${outsideBackWallDustFlapRight.height}
    M ${topSide.left} ${topSide.top}
    v ${topSide.height}
    M ${topSide.left + topSide.width} ${topSide.top}
    v ${topSide.height}
    M ${frontFlapOutside.left} ${frontFlapOutside.top + 2*MT}
    v ${frontFlapOutside.height - 2*MT}
    M ${frontFlapOutside.left + frontFlapOutside.width} ${frontFlapOutside.top + 2*MT}
    v ${frontFlapOutside.height - 2*MT}
  `
  // Blue part of foldlines
  const blueLines = `
    M ${outsideFrontDustFlapLeft.left} ${outsideFrontDustFlapLeft.top + outsideFrontDustFlapLeft.height}
    h ${outsideFrontDustFlapLeft.width - 4*MT}
    l ${4*MT} ${MT}
    M ${outsideFrontDustFlapRight.left + outsideFrontDustFlapRight.width} ${outsideFrontDustFlapRight.top + outsideFrontDustFlapRight.height}
    h ${-outsideFrontDustFlapRight.width +  4*MT}
    l ${-4*MT} ${MT}
    M ${outsideBackWallDustFlapLeft.left} ${outsideBackWallDustFlapLeft.top}
    h ${outsideBackWallDustFlapLeft.width - 2*MT}
    l ${2*MT} ${-MT}
    M ${outsideBackWallDustFlapRight.left + outsideBackWallDustFlapRight.width} ${outsideBackWallDustFlapRight.top}
    h ${-outsideBackWallDustFlapRight.width +  2*MT}
    l ${-2*MT} ${-MT}
  `
  return {
    redArea,
    whiteFoldLines,
    blueLines
  }
}

function getCutlines(box, printSide = 'outside') {
  const {
    redArea,
    whiteFoldLines,
    blueLines
  } = createCutlinesPathDefinition(box)

  const transformElement = printSide === 'inside'
    ? `transform: scaleX(-1); transform-origin: center;`
    : ''

  // Red part of foldlines
  // style="${transformElement}"
  let path = `
    <path
      stroke="red"
      fill="none"
      stroke-dasharray="10 10"
      d="${redArea}" />
  `

  // White part of foldlines
  // style="${transformElement}"
  path += `
    <path
      stroke="white"
      fill="none"
      stroke-dasharray="10 10"
      stroke-dashoffset="10"
      d="${whiteFoldLines}" />
  `

  // style="${transformElement}"
  path += `
    <path
      stroke="blue"
      fill="none"
      d="${blueLines}" />
  `
  return path
}

export {
  getSvgForGeom,
  get2DEditorSvg,
  getOutlineWithBleed,
  getOutlineWithoutNonPrintPanels,
  getOutline,
  getCutlines,
};
